// extracted by mini-css-extract-plugin
export default {"main":"transaction-result_main__EDsB2","actions":"transaction-result_actions__wuiPU"};